import fonts from './../../assets/data/fonts.json'

const state = {
  fonts: {
    available: fonts,
  },
  currentFont: {},
  filters: {
    type: 'all',
    weight: 'all'
  }
}

const mutations = {
  SET_FILTERS(state, payload) {
    state.filters = payload;
  },
  SET_AVAILABLE_FONTS(state, payload) {
    state.fonts.available = payload;
  },
  SET_CURRENT_FONT(state, payload) {
    state.currentFont = payload;
  }
}

const actions = {
  setFilters({ commit }, payload) {
    let _fonts = fonts;
    
    if (payload.type !== 'all') {
      _fonts = _fonts.filter((font) => font.type === payload.type);
    }

    if (payload.weight !== 'all') {
      _fonts = _fonts.filter((font) => payload.weight in font.weights);
    }

    commit('SET_FILTERS', payload);
    commit('SET_AVAILABLE_FONTS', _fonts);
  },
  setNewFont({ commit, state }) {
    const font = state.fonts.available[Math.floor(Math.random()*state.fonts.available.length)];
    const weight = state.filters.weight === 'all'
      ? Object.keys(font.weights)[Math.floor(Math.random()*Object.keys(font.weights).length)]
      : state.filters.weight;
    const fontFace = new FontFace(font.css, `url(${font.weights[weight]})`);
    fontFace.load().then(loadedFont => {
      document.fonts.add(loadedFont);
      commit('SET_CURRENT_FONT', {
        ...font,
        weight: weight
      });
    });
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}